module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./NewOrderEvaluate.js"));
	}, "OrderEvaluateView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=OrderEvaluateView!./src/pages/Shop/Member/TradeManage/OrderEvaluate/NewOrderEvaluate.js
// module id = 1949
// module chunks = 367